import { red } from "material-ui/colors";
import { createMuiTheme } from "material-ui/styles";
import { fade } from "material-ui/styles/colorManipulator";

const buttonColor = "#4A3E92";
const removeColor = "#a4375e";
const theme = createMuiTheme({
  typography: {
    htmlFontSize: 14
  },
  palette: {
    primary: {
      light: buttonColor,
      main: "#023431",
      dark: "#00001f"
    },
    secondary: {
      light: "#ff98bb",
      main: "#26a69a",
      dark: "#a4375e"
    },
    error: red,
    link: "#2196F3",
    answer: {
      main: "#678ecc",
      dark: "#4d71ab",
      light: "#7da2de",
      backgroundColor: "rgba(103, 142, 204, 0.12)",
      borderColor: "#b1bed4"
    },
    remove: {
      light: fade(removeColor, 0.7),
      dark: removeColor
    }
  },
  overrides: {
    MuiTypography: {
      title: {
        fontSize: "1.3rem",
        fontWeight: 800
      }
    },
    MuiButton: {
      root: {
        color: "#2196F3",
        "&:hover": {
          backgroundColor: "#ffffff00"
        }
      },
      flatPrimary: {
        color: buttonColor,
        "&:hover": {
          backgroundColor: fade(buttonColor, 0.1),
          // Reset on mouse devices
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        }
      },
      label: {
        textTransform: "none"
      },
      raised: {
        color: "#f4f5f8",
        backgroundColor: buttonColor,
        "&:hover": {
          backgroundColor: fade(buttonColor, 0.7),
          // Reset on mouse devices
          "@media (hover: none)": {
            backgroundColor: buttonColor
          }
        }
      },
      dense: {
        padding: "4px 8px 2px",
        minWidth: 60,
        fontSize: "0.9rem",
        minHeight: 22
      }
    },
    MuiLinearProgress: {
      primaryColor: {
        backgroundColor: "#f4f5f8"
      },
      primaryColorBar: {
        backgroundColor: "#2196f3"
      }
    },
    MuiBottomNavigation: {
      root: {
        height: 32,
        backgroundColor: "#f4f5f8",
        justifyContent: "left"
      }
    },
    MuiBottomNavigationAction: {
      root: {
        borderRight: "#fff solid 1px",
        color: "#333",
        "&:focus": {
          color: "#fff",
          backgroundColor: "#26a69a",
          // Reset on mouse devices
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        },
        "&:last-child": {
          borderRight: "none"
        }
      }
    },
    MuiCheckbox: {
      checked: {
        color: "#26a69a"
      }
    },
    MuiInput: {
      root: {
        padding: 0,
        outline: "none"
      },
      input: {
        border: "1px solid #ced4da",
        padding: "4px 12px",
        fontSize: 16,
        transition:
          "border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        borderRadius: 4,
        backgroundColor: "#fff"
      },
      formControl: {
        marginTop: 16
      },
      inputSingleline: {
        height: "1.3rem"
      },
      inputMultiline: {
        padding: "4px 12px"
      }
    },
    MuiTextarea: {
      textarea: {
        width: "96% !important"
      }
    },
    MuiSelect: {
      select: {
        padding: "4px 12px",
        "&:focus": {
          borderRadius: 5
        }
      },
      icon: {
        top: 2
      }
    },
    MuiTooltip: {
      root: {
        display: "block",
        float: "right"
      },
      tooltip: {
        color: "#555",
        fontSize: "16px !important",
        border: "2px solid #009688",
        backgroundColor: "rgba(255, 255, 255, 1)",
        borderRadius: 4,
        padding: "8px 14px !important",
        boxShadow:
          "0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)"
      }
    },
    MuiPaper: {
      root: {
        minWidth: 0
      }
    },
    MuiDialog: {
      paperWidthSm: {
        maxWidth: "inherit"
      }
    },
    MuiFormLabel: {
      root: {
        fontSize: "1.1rem"
      }
    },
    MuiDialogTitle: {
      root: {
        color: "#575962",
        borderBottom: "1px solid darkgrey"
      }
    },
    MuiDialogContent: {
      root: {
        borderBottom: "1px solid darkgrey",
        padding: 30
      }
    },
    MuiDialogActions: {
      root: {
        justifyContent: "center"
      },
      button: {
        minWidth: 120
      }
    }
  }
});

export default theme;



// WEBPACK FOOTER //
// ./src/theme.js